import { JSX, memo } from "react"
import logo from "@/assets/img/logo.png"

const styles = {
    container: "mx-auto w-full max-w-container px-8 mt-20 w-full bottom-0 left-0 z-50",
    wrapper: "mx-auto max-w-screen-xl space-y-4 px-4 py-12 sm:px-6 lg:space-y-6 lg:px-8",
    topRow: "flex flex-col items-center justify-center gap-4 sm:flex-row sm:items-center sm:justify-between",
    logoRow: "w-full flex justify-center sm:block",
    logo: "text-teal-600",
    logoImg: "h-8",
    socialList: "flex flex-row gap-4 justify-center mt-4 sm:mt-0 sm:gap-6 sm:justify-end w-full sm:w-auto",
    socialLink: "text-teal-700 transition hover:text-teal-700/75",
    socialIcon: "size-6",
    divider: "mt-6 border-t border-gray-100 pt-6",
    bottomRow: "text-center sm:flex sm:justify-between sm:text-left",
    legal: "text-sm text-gray-500",
    link: "inline-block text-teal-600 underline transition hover:text-teal-600/75",
    copyright: "mt-4 text-sm text-gray-500 sm:order-first sm:mt-0"
};

const FooterSection = memo((): JSX.Element => {
    return (
        <footer className={styles.container}>
            <div className={styles.wrapper}>
                <div className={styles.topRow}>
                    {/* Logo centrado en su propia fila en mobile */}
                    <div className={styles.logoRow}>
                        <div className={styles.logo}>
                            <img
                                src={logo} alt="Logo" className={styles.logoImg}
                                width={100} height={100}
                                style={{ width: "200px", height: "auto" }}
                            />
                        </div>
                    </div>
                    {/* Iconos en su propia fila en mobile, a la derecha en sm+ */}
                    <ul className={styles.socialList}>
                        {/* ...existing code... */}
                        <li>
                            <a
                                href="https://www.facebook.com/61574557344772/"
                                rel="noreferrer"
                                target="_blank"
                                className={styles.socialLink}
                            >
                                <span className="sr-only">Facebook</span>
                                <svg className={styles.socialIcon} fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                                    <path
                                        fillRule="evenodd"
                                        d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z"
                                        clipRule="evenodd"
                                    />
                                </svg>
                            </a>
                        </li>
                        <li>
                            <a
                                href="https://www.instagram.com/appcotas"
                                rel="noreferrer"
                                target="_blank"
                                className={styles.socialLink}
                            >
                                <span className="sr-only">Instagram</span>
                                <svg className={styles.socialIcon} fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                                    <path
                                        fillRule="evenodd"
                                        d="M12.315 2c2.43 0 2.784.013 3.808.06 1.064.049 1.791.218 2.427.465a4.902 4.902 0 011.772 1.153 4.902 4.902 0 011.153 1.772c.247.636.416 1.363.465 2.427.048 1.067.06 1.407.06 4.123v.08c0 2.643-.012 2.987-.06 4.043-.049 1.064-.218 1.791-.465 2.427a4.902 4.902 0 01-1.153 1.772 4.902 4.902 0 01-1.772 1.153c-.636.247-1.363.416-2.427.465-1.067.048-1.407.06-4.123.06h-.08c-2.643 0-2.987-.012-4.043-.06-1.064-.049-1.791-.218-2.427-.465a4.902 4.902 0 01-1.772-1.153 4.902 4.902 0 01-1.153-1.772c-.247-.636-.416-1.363-.465-2.427-.047-1.024-.06-1.379-.06-3.808v-.63c0-2.43.013-2.784.06-3.808.049-1.064.218-1.791.465-2.427a4.902 4.902 0 011.153-1.772A4.902 4.902 0 015.45 2.525c.636-.247 1.363-.416 2.427-.465C8.901 2.013 9.256 2 11.685 2h.63zm-.081 1.802h-.468c-2.456 0-2.784.011-3.807.058-.975.045-1.504.207-1.857.344-.467.182-.8.398-1.15.748-.35.35-.566.683-.748 1.15-.137.353-.3.882-.344 1.857-.047 1.023-.058 1.351-.058 3.807v.468c0 2.456.011 2.784.058 3.807.045.975.207 1.504.344 1.857.182.466.399.8.748 1.15.35.35.683.566 1.15.748.353.137.882.3 1.857.344 1.054.048 1.37.058 4.041.058h.08c2.597 0 2.917-.01 3.96-.058.976-.045 1.505-.207 1.858-.344.466-.182.8-.398 1.15-.748.35-.35.566-.683.748-1.15.137-.353.3-.882.344-1.857.048-1.055.058-1.37.058-4.041v-.08c0-2.597-.01-2.917-.058-3.96-.045-.976-.207-1.505-.344-1.858a3.097 3.097 0 00-.748-1.15 3.098 3.098 0 00-1.15-.748c-.353-.137-.882-.3-1.857-.344-1.023-.047-1.351-.058-3.807-.058zM12 6.865a5.135 5.135 0 110 10.27 5.135 5.135 0 010-10.27zm0 1.802a3.333 3.333 0 100 6.666 3.333 3.333 0 000-6.666zm5.338-3.205a1.2 1.2 0 110 2.4 1.2 1.2 0 010-2.4z"
                                        clipRule="evenodd"
                                    />
                                </svg>
                            </a>
                        </li>
                        <li>
                            <a
                                href="https://www.linkedin.com/company/appcotas"
                                rel="noreferrer"
                                target="_blank"
                                className={styles.socialLink}
                            >
                                <span className="sr-only">LinkedIn</span>
                                <svg className={styles.socialIcon} fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                                    <path d="M19 0h-14c-2.76 0-5 2.24-5 5v14c0 2.76 2.24 5 5 5h14c2.76 0 5-2.24 5-5v-14c0-2.76-2.24-5-5-5zm-11.75 20h-3v-10h3v10zm-1.5-11.27c-.97 0-1.75-.79-1.75-1.76 0-.97.78-1.76 1.75-1.76s1.75.79 1.75 1.76c0 .97-.78 1.76-1.75 1.76zm15.25 11.27h-3v-5.6c0-1.34-.03-3.07-1.87-3.07-1.87 0-2.16 1.46-2.16 2.97v5.7h-3v-10h2.88v1.36h.04c.4-.75 1.38-1.54 2.84-1.54 3.04 0 3.6 2 3.6 4.59v5.59z" />
                                </svg>
                            </a>
                        </li>
                    </ul>
                </div>


                <div className={styles.divider}>
                    <div className={styles.bottomRow}>
                        <p className={styles.legal}>
                            <span className="block sm:inline">All rights reserved.</span>

                            <a
                                className={styles.link}
                                href="terms"
                            >
                                Terms & Conditions
                            </a>

                            <span>&nbsp;&middot;&nbsp;</span>

                            <a
                                className={styles.link}
                                href="policy"
                            >
                                Privacy Policy
                            </a>
                        </p>

                        <p className={styles.copyright}>
                            &copy; {new Date().getFullYear()} AppCotas
                        </p>
                    </div>
                </div>
            </div>
        </footer>
    );
});

export default FooterSection